import { render, staticRenderFns } from "./ikk_outcome.vue?vue&type=template&id=cf05b512&"
import script from "./ikk_outcome.vue?vue&type=script&lang=js&"
export * from "./ikk_outcome.vue?vue&type=script&lang=js&"
import style0 from "./ikk_outcome.vue?vue&type=style&index=0&id=cf05b512&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QSelect,QBtnGroup,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QSelect,QBtnGroup,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
